import Backbone from "backbone";
import { View } from "../database-reader/base-database-reader";
import { DB_PROVIDERS } from "../database-reader/configs/db-providers";
const module = {};
class ServiceNowView extends View {
    setup() {
        this.label = "ServiceNow";
        this.model.get("connectionParams").set("type", DB_PROVIDERS.SERVICENOW.id);
        this.model.set("isCDC", false);
    }
}

module.View = ServiceNowView;
module.vent = new Backbone.Model();
export default module;
